<template>
    <a-layout style="min-height: 100vh">
      <a-layout-sider v-model:collapsed="collapsed" :trigger="null" collapsible theme="light">
        <!-- TODO: [Frankie] Upload the Logo and figure out the display between collapsed and non-collapsed -->
        <a href="/home">
          <img width="40px" src="@/assets/dashboard-icon.png" class="center"/>
        </a>
        <a-menu v-model:selectedKeys="selectedKeys" theme="light" mode="inline" style="padding-top: 10px;">
          <a-menu-item key="ProjectManager" @click="routingToPage('ProjectManager')">
            <ProfileOutlined />
            <span style="text-decoration: none; color: inherit;">專案管理</span>
          </a-menu-item>
          <a-sub-menu key="ProjectReport">
            <template #title>
                <AreaChartOutlined />
                <span>專案圖表</span>
            </template>
            <a-menu-item key="ProjectCompletenessReport" @click="routingToPage('ProjectCompletenessReport')">
                <BarChartOutlined />
                <span style="text-decoration: none; color: inherit;">問卷填寫統計</span>
            </a-menu-item>
            <a-menu-item key="ProjectUnImportReport" @click="routingToPage('ProjectUnImportReport')">
                <BarsOutlined />
                <span style="text-decoration: none; color: inherit;">未匯入人員總覽</span>
            </a-menu-item>
            <a-menu-item key="ProjectStatusReport" @click="routingToPage('ProjectStatusReport')">
                <PieChartOutlined />
                <span style="text-decoration: none; color: inherit;">專案數量統計</span>
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item key="UserSetting" @click="routingToPage('UserSetting')">
            <SettingOutlined />
            <span style="text-decoration: none; color: inherit;">系統設定</span>
          </a-menu-item>
          <a-menu-item key="About">
            <ExclamationCircleOutlined />
            <span><router-link style="text-decoration: none; color: inherit;" :to="{name:'About'}">關於本系統</router-link></span>
          </a-menu-item>
          <a-menu-item key="Logout" @click="performLogout">
            <LogoutOutlined />
            <span>登出系統</span>
          </a-menu-item>
        </a-menu>
      </a-layout-sider>
      <a-layout>
        <a-layout-header :style="{ background: '#fff', padding: 0 }">
          <menu-unfold-outlined style="width: 3em; font-size: 25px;" v-if="collapsed" class="trigger" @click="() => (collapsed = !collapsed)" />
          <menu-fold-outlined style="width: 3em; font-size: 25px;" v-else class="trigger" @click="() => (collapsed = !collapsed)" />
          <a-space style="float: right; margin-right: 50px;" size="large">
            <span style="font-size: 18px;">您好，{{ userDisplayName }}</span><UserOutlined style="width: 2em; font-size: 20px;"/>
          </a-space>
        </a-layout-header>
        <a-layout-content style="margin: 0 16px">
          <router-view></router-view>
        </a-layout-content>
        <a-layout-footer style="text-align: center">
          &copy; 2025 RGB Technology, all rights reserved.
        </a-layout-footer>
      </a-layout>
    </a-layout>
  </template>
  
<script setup>
import {
  ProfileOutlined, PieChartOutlined, UserOutlined, LogoutOutlined, 
  MenuFoldOutlined, MenuUnfoldOutlined, ExclamationCircleOutlined, 
  AreaChartOutlined, BarsOutlined, BarChartOutlined, SettingOutlined
} from "@ant-design/icons-vue";
import { ref, onMounted } from 'vue';

import common from "@/common";
import config from "@/config";
import router from "@/router";

const collapsed = ref(false);
const currentPageName = ref("ProjectManager");
const userDisplayName = ref("");
const selectedKeys = ref(['ProjectManager']);

const performLogout = () => {
  common.removeToken(() => router.push('/'));
}

const routingToPage = (routingName) => {
  currentPageName.value = routingName;
  router.push({
    name: currentPageName.value
  });
}

onMounted(() => {
  userDisplayName.value = "未知使用者";
  common.getRequest(config.mgmtUserEntity, (response) => {
    userDisplayName.value = response.data.userConfig.displayName;
    routingToPage(currentPageName.value);
  }, () => {
    if (process.env.NODE_ENV === 'local') {
      return ;
    }
    router.push('/');
  });
});
</script>
<style scoped>
  button,
  span {
    display: inline-flex;
    align-items: center;
  }
  .center {
    display: block;
    margin-top: 5px;
    margin-left: auto;
    margin-right: auto;
  }
</style>
  